import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { TokenValid } from "src/classes/Automation/TokenValid";
import { ScreenSizeService } from "../../services/Common/screen-size/screen-size.service";
import { User } from "src/classes/Automation/UserApp";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-mainsms",
    templateUrl: "./mainsms.component.html",
    styleUrls: ["./mainsms.component.css"],
    providers: [HttpService1],
})
export class MainsmsComponent implements OnInit {
    user: User = new User();
    receiveduser: User = new User();

    tokenvalid: TokenValid = new TokenValid();
    receivetokenvalid: TokenValid = new TokenValid();

    // fastemail: string;

    scrWidth: number;

    constructor(
        private router: Router,
        private httpService1: HttpService1,
        private screenSizeService: ScreenSizeService,
        private logger: NGXLogger,
    ) { }

    ngOnInit() {
        // this.fastemail = this.Activatedroute.snapshot.queryParamMap.get("email") || "0";
        // console.log("fastemail value: " + this.fastemail);
        // this.logger.info("fastemail value: " + this.fastemail);

        // if (this.fastemail != '0') {

        //     sessionStorage.removeItem('email');
        //     sessionStorage.setItem('email', this.fastemail);
        //     // fast user authorization
        //     this.user.useremail = this.fastemail;
        //     this.httpService1.postDataLogin(this.user).subscribe((res: User) => {
        //         this.receiveduser = res; this.receiveduser.useremail = res.useremail; this.receiveduser.token = res.token;
        //         sessionStorage.setItem('token', this.receiveduser.token);
        //         console.log('Test: ' + res.useremail);
        //         this.logger.info('Test: ' + res.useremail);
        //         if (!res.useremail) {
        //             this.router.navigate(['']); console.log("Valid email:not");
        //             this.logger.info("Valid email:not");
        //         }
        //         else
        //             //this.router.navigate(['mainsms']);
        //             //?sessionStorage.setItem('email', this.fastemail);
        //             console.log("Valid email:yes");
        //         this.logger.info("Valid email:yes");
        //     }, error => console.log(error));

        //     this.logger.info('Connected client of user with email: ' + sessionStorage.getItem('email'));
        // }

        this.scrWidth = this.screenSizeService.getScreenWidth();
        window.addEventListener("resize", () => {
            this.scrWidth = this.screenSizeService.getScreenWidth();
        });

        this.user.useremail = sessionStorage.getItem("email");
        this.user.userpassword = sessionStorage.getItem("password");
        console.log(this.user);

        this.httpService1.postDataLogin(this.user).subscribe((res: User) => {
            this.receiveduser = res;
            this.receiveduser.useremail = res.useremail;
            this.receiveduser.token = res.token;

            sessionStorage.setItem("tokenAutomation", this.receiveduser.token);
            console.log("Test: " + res.useremail);

            if (!res.token) {
                console.log("Not valid email:" + this.user.useremail);
                this.logger.error("Not valid email: " + sessionStorage.getItem("email"));
                this.router.navigate(["login"]);
            }
        }, error => {
            console.log(error);
            this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
        });
    }

    onSelect(): void {
        // if token valid
        this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");

        if (!this.tokenvalid.token) {
            this.httpService1.postDataLogin(this.user).subscribe((res: User) => {
                sessionStorage.setItem("tokenAutomation", res.token);
                this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");

                if (!res.token) {
                    console.log("Not valid email:" + this.user.useremail);
                    this.logger.error("Not valid email: " + sessionStorage.getItem("email"));
                    this.router.navigate([""]);
                    return;
                }

                this.httpService1.postIsTokenValid(this.tokenvalid)
                    .subscribe((res: TokenValid) => {
                        this.receivetokenvalid = res;
                        this.receivetokenvalid.answer = res.answer;
                        if (!this.receivetokenvalid.answer) {
                            this.logger.info("Token not valid for user with email: " + sessionStorage.getItem("email"));
                            this.router.navigate(["login"]);
                        }
                    }, error => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        }
        else {
            this.httpService1.postIsTokenValid(this.tokenvalid)
                .subscribe((res: TokenValid) => {
                    this.receivetokenvalid = res;
                    this.receivetokenvalid.answer = res.answer;
                    if (!this.receivetokenvalid.answer) {
                        this.logger.info("Token not valid for user with email: " + sessionStorage.getItem("email"));
                        this.router.navigate(["login"]);
                    }
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }

    goTemplates() {
        // if token valid
        this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");

        if (!this.tokenvalid.token) {
            this.httpService1.postDataLogin(this.user).subscribe((res: User) => {
                sessionStorage.setItem("tokenAutomation", res.token);
                this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");

                if (!res.token) {
                    console.log("Not valid email:" + this.user.useremail);
                    this.logger.error("Not valid email: " + sessionStorage.getItem("email"));
                    this.router.navigate([""]);
                    return;
                }

                this.httpService1.postIsTokenValid(this.tokenvalid)
                    .subscribe((res: TokenValid) => {
                        this.receivetokenvalid = res;
                        this.receivetokenvalid.answer = res.answer;
                        if (this.receivetokenvalid.answer) {
                            this.router.navigate(["mainsms", "template"]);
                        } else {
                            this.logger.info("Token not valid for user with email: " + sessionStorage.getItem("email"));
                            this.router.navigate(["login"]);
                        }
                    }, error => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        }
        else {
            this.httpService1.postIsTokenValid(this.tokenvalid)
                .subscribe((res: TokenValid) => {
                    this.receivetokenvalid = res;
                    this.receivetokenvalid.answer = res.answer;
                    if (this.receivetokenvalid.answer) {
                        this.router.navigate(["mainsms", "template"]);
                    } else {
                        this.logger.info("Token not valid for user with email: " + sessionStorage.getItem("email"));
                        this.router.navigate(["login"]);
                    }
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }
}
